module.exports = __webpack_public_path__ + "img/aqfh-img-21.eddf42f3.png";